import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { flatten, pluck, prop, sortBy } from 'ramda';

import { getCityNameWithState } from '../utils/format';
import { getCrimes } from '../selectors/crimes';
import { getSafeMetric } from '../selectors/options';
import { MetricProp, VisType } from '../constants';

import ChartAndLegend from './ChartAndLegend';
import { getLegendData, setYFromValues } from './RecurringChartContainer';
import GenericBarChart, { placeGroupedData } from './GenericBarChart';

export const getRawData = createSelector(
  getLegendData,
  getCrimes,
  getSafeMetric,
  (legend, crimes, metric) =>
    legend.map(({ id, name, state, color }) =>
      sortBy(prop('timespan'), crimes[id].slice(0, 2)).map((d, intervalId) => ({
        id,
        name,
        state,
        intervalId,
        date: intervalId,
        value: d[MetricProp[metric]],
        fill: color,
        timespanInterval: d.timespan,
      })),
    ),
);

const barWidth = 24;
const barSpacing = 8;
const groupSpacing = 32;

export const getPlacedData = createSelector(getRawData, data =>
  setYFromValues(
    flatten(placeGroupedData(data, barWidth, barSpacing, groupSpacing)),
  ),
);

export const getXTickValues = createSelector(getPlacedData, pluck('x'));

export const getXTickLabels = createSelector(getPlacedData, data =>
  data.map(bar => (bar.intervalId === 0 ? 'TI 1' : 'TI 2')),
);

export default connect(state => ({
  chartComponent: GenericBarChart,
  chartData: getPlacedData(state),
  legendData: getLegendData(state),
  resetSelectionOnClick: true,
  xTickLabels: getXTickLabels(state),
  xTickValues: getXTickValues(state),
  showVerticalGrid: false,
  labelAnchor: 'middle',
  hoverHPadding: barSpacing / 2 - 0.75,
  // FIXME: this have nothing to do with mapStateToProps
  // nor does it with mapDispatchToProps
  onMouseOver: (
    { id, value, timespanInterval, fill, name, state, intervalId },
    { setHovered },
    [offsetX, offsetY],
  ) => {
    setHovered(id, intervalId, null, {
      timespanInterval,
      x: offsetX,
      y: offsetY,
      visType: VisType.COMPARISON,
      mainValue: value,
      sideColor: fill,
      title: getCityNameWithState(name, state),
    });
  },
  onMouseOut: ({ id, intervalId }, { setHovered }) => {
    setHovered(null, null, id, null);
  },
  onClick: ({ id }, { setSelected }) => {
    setSelected(id);
  },
}))(ChartAndLegend);



// WEBPACK FOOTER //
// ./src/components/ComparisonChartContainer.jsx